import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
import { getKeyMetric, getShortNameForMetric } from './cell-semi-annually';
interface CellAnnuallyProps {
  metrics: Partial<MetricValues>;
  activeMetrics: string[];
}
function CellAnnually(t0) {
  const $ = _c(13);
  const {
    metrics,
    activeMetrics
  } = t0;
  const activeMetricsCount = activeMetrics.length;
  const t1 = activeMetricsCount === 3 && "[&>div:nth-of-type(3)]:after:left-1";
  const t2 = activeMetricsCount === 2 && "[&>div:nth-of-type(2)]:after:-bottom-1.5 [&>div:nth-of-type(2)]:after:left-0.5 [&>div:nth-of-type(2)]:after:h-[42px]";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cn("flex w-full flex-row justify-center font-medium", t1, t2, "gap-0 pl-0 2xl:gap-[60px] 2xl:pl-5");
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeMetrics || $[4] !== activeMetricsCount || $[5] !== metrics) {
    let t5;
    if ($[7] !== activeMetricsCount || $[8] !== metrics) {
      t5 = (metric, index) => <div key={index} className={cn("relative flex flex-1 flex-col p-0", "w-20 xl:w-48 2xl:w-[78px]", "after:border-border after:absolute after:bottom-2.5 after:h-12 after:border-r after:content-[\"\"]", "md:after:hidden", activeMetricsCount === 3 && index === 2 && "after:left-1", activeMetricsCount === 2 && index === 1 && "after:-bottom-1.5 after:left-0.5 after:h-[42px]")}><div className="text-muted-foreground mb-1 text-center text-xs leading-normal font-normal">{getShortNameForMetric(metric)}</div><div className="text-foreground text-center text-xs leading-[18px] font-semibold">{usLocalizedNumber(metrics[getKeyMetric(metric) as keyof MetricValues] ?? 0)}</div></div>;
      $[7] = activeMetricsCount;
      $[8] = metrics;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = activeMetrics.map(t5);
    $[3] = activeMetrics;
    $[4] = activeMetricsCount;
    $[5] = metrics;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export { CellAnnually };